// Provides a method for preventing body scroll when key events occur - such as opening dialogues, activating menus and so forth.

const lockClass = 'body-lock'

const bodyHtml = document.querySelectorAll('body, html')

const stopBodyScroll = (dataLockAttribute = '') => {
  if (!document.body.classList.contains(lockClass)) {
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.height = `calc(100vh + ${window.scrollY}px)`
    document.body.classList.add(lockClass)
    document.body.style.position = 'fixed'
    document.body.style.overflow = 'hidden'
    window.scrollTo(0, parseInt(window.scrollY || '0') * -1)
    if (dataLockAttribute !== '') {
      document.body.setAttribute('data-lock', dataLockAttribute)
    }
  }
}

const allowBodyScroll = (timeout = 500) => {
  for (const elem of bodyHtml) {
    elem.style.scrollBehavior = 'auto'
  }
  setTimeout(() => {
    if (document.body.classList.contains(lockClass)) {
      document.body.classList.remove(lockClass)
      const scrollY = document.body.style.top
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.height = ''
      document.body.style.overflow = ''
      document.body.removeAttribute('data-lock')

      window.scrollTo({
        top: parseInt(scrollY || '0') * -1,
        left: 0,
        behavior: 'auto'
      })
    }
    for (const elem of bodyHtml) {
      elem.style.removeProperty('scroll-behavior')
    }
  }, timeout)
}

export {
  stopBodyScroll,
  allowBodyScroll
}
